import React from "react";
import { Link } from "react-router-dom";
import { arrow } from "../assets/icons";

const InfoBox = ({ text, link, btnText }) => (
  <div className="info-box">
    <p className="font-medium sm:text-xl text-center">{text}</p>
    <Link to={link} className="neo-brutalism-white neo-btn">
      {btnText}
      <img src={arrow} alt="->" className="w-4 h-4 object-contain" />
    </Link>
  </div>
);

const renderContent = {
  1: (
    <h1 className="sm:text-xl sm:leading-snug text-center neo-brutalism-blue py-4 px-8 text-white mx-5">
      Hi, I am <span className="font-semibold">Adarsh</span>
      <br />I am Software Engineer from Bangalore
    </h1>
  ),
  2: (
    <h1>
      <InfoBox
        text="Worked with many companies and picked up many skills alog the way"
        link="/about"
        btnText="Learn more"
      ></InfoBox>
    </h1>
  ),
  3: (
    <h1>
      <InfoBox
        text="Led multiple projects to success over the years. Curious about the impact?"
        link="/projects"
        btnText="Visit my portfolio"
      ></InfoBox>
    </h1>
  ),
  4: (
    <h1>
      <InfoBox
        text="Need a project done or looking for a dev? I'm just few keystrokes away"
        link="/contact"
        btnText="Let's talk"
      ></InfoBox>
    </h1>
  ),
};

const HomeInfo = ({ currentStage }) => {
  return renderContent[currentStage] || null;
};

export default HomeInfo;
